import fetcher from '@/utils/fetcher';

const postCancelUnregistMember = async (email: string) => {
  try {
    const res = await fetcher.post('/api/auth/unregist', {
      data: {
        email,
        is_cancel: true,
      },
    });
    return res.status === 200;
  } catch (e: any) {
    return false;
  }
};

export default postCancelUnregistMember;
